import {UserTracker} from "../index.js";

const eventDics = {
    "okr": "main:top-menu-okr:click", // okr 클릭
    "portal": "main:top-menu-portal:click", // 포탈 클릭
    "letter": "main:top-menu-letter:click", // 쪽지 클릭
    "org": "main:top-menu-org:click", // 조직도 클릭
    "chat": "main:top-menu-chat:click", // 채팅 클릭
    "alarm": "main:top-menu-alarm:click", // 알림 클릭
    "profile": "main:top-menu-profile:click", // 프로필 클릭
    "search": "main:top-menu-search:click", // 검색 클릭
    "electron-history-back": "main:top-menu-electron-history-back:click", // 일렉트론 undo
    "electron-history-forward": "main:top-menu-electron-history-forward:click", // 일렉트론 redo
    "electron-reload-btn": "main:top-menu-electron-reload-btn:click", // 일렉트론 reload
    "electron-reload-menu": "main:top-menu-electron-reload-menu:click", // 일렉트론 메뉴?
}

export const TopMenuTracker = () => {
    const Tracker = Object.create(UserTracker)
    Tracker.track = (eventName) => {
        const event = eventDics[eventName];
        if (!event) return;

        return Tracker.trackAction({event: event, value: null, data: {}});
    }

    return Tracker;
}